/**
 * Onboarding gate — sits inside DashboardLayout. On every mount it asks
 * the server "is this user's onboarding complete?". If not, it redirects
 * to /onboarding. If yes, it transparently renders children.
 *
 * Cheap: the call is hit once per layout-mount (login or page refresh),
 * not on every navigation.
 */
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";

export default function OnboardingGate({ children }) {
    const navigate = useNavigate();
    const loc = useLocation();
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        let active = true;
        api.get("/onboarding/state").then(({ data }) => {
            if (!active) return;
            if (data.flow !== "none" && data.stage !== "complete" && !loc.pathname.startsWith("/onboarding")) {
                navigate("/onboarding", { replace: true });
            } else {
                setChecked(true);
            }
        }).catch(() => { if (active) setChecked(true); });
        return () => { active = false; };
    }, [navigate, loc.pathname]);

    if (!checked) return null;     // suppress flash of dashboard until check completes
    return children;
}
